import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import type { ComponentPropsWithoutRef } from "react";

import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

import { CTASettingsModalComponent } from "./CTASettingsModalComponent";
import { CTASettingsModalUIKitComponent } from "./CTASettingsModalUIKitComponent";

type CTASettingsModalUIKitComponentProps = ComponentPropsWithoutRef<
  typeof CTASettingsModalUIKitComponent
>;

const CTASettingsModalUIKit = ModalManager.create(
  (props: CTASettingsModalUIKitComponentProps) => (
    <CTASettingsModalUIKitComponent {...props} />
  ),
);

type CTASettingsModalComponentProps = Omit<
  ComponentPropsWithoutRef<typeof CTASettingsModalComponent>,
  "open" | "onOpenChange"
>;

const CTASettingsModal = ModalManager.create(
  (props: CTASettingsModalComponentProps) => {
    const modal = useModal();

    return (
      <CTASettingsModalComponent
        {...props}
        open={modal.visible}
        onOpenChange={open => {
          if (!open) {
            void modal.hide();
          }
        }}
      />
    );
  },
);

export const useCTASettingsModal = () => {
  const isCircleV4 = useIsCircleV4FeatureEnabled("circle_v4_modals_enabled");
  const ModalComponent = isCircleV4 ? CTASettingsModal : CTASettingsModalUIKit;

  return useModal(ModalComponent);
};
